
import { FormContainer } from 'project/modules/forms/formContainer';

export class InputForm extends FormContainer {

    constructor(properties) {
        super(properties);
        this.container = properties.container;
        this.modules = properties.modules;
        this.data = properties.data;
    }

    createForms() {
        this.formsData.parseForms([]);
        document.querySelector(`#${this.container}`).className = 'inputForm';
    }

    updateData(values = null) {
        if (values != null) {
            Object.keys(values.data).forEach(key => {
                if (values.data[key] !== null) {
                    this.setFieldValue(values.data[key].key, values.data[key].value);
                    if (values.data[key].prop) {
                        this.setFieldValue(`${values.data[key].key}_OPT`, values.data[key].prop);
                    }
                }
            });
        } else {
            Object.keys(this.data.data).forEach(key => {
                if (this.data.data[key] !== null) {
                    this.setFieldValue(this.data.data[key].key, this.data.data[key].value);
                    if (this.data.data[key].prop) {
                        this.setFieldValue(`${this.data.data[key].key}_OPT`, this.data.data[key].prop);
                    }
                }
            });
        }

        this.clear();
        this.update();
    }
}